import type { ChatRequestMessagesItemRole } from './chatRequestMessagesItemRole';

export type ChatRequestMessagesItem = {
  /** 메시지 내용 */
  content: string;
  /** 메시지 역할 */
  role: ChatRequestMessagesItemRole;
};
